"use strict";
/**
 * @file Created on Fri Aug 24 2018
 * @author VBr
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checkes number's an integer
 */


var IntegerValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(IntegerValidator, _Validator_1$Validato);

  function IntegerValidator() {
    _classCallCheck(this, IntegerValidator);

    return _possibleConstructorReturn(this, _getPrototypeOf(IntegerValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
  }

  _createClass(IntegerValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (!Number.isInteger(value)) {
        return new ValidationResult_1.ValidationError(IntegerValidator.NOT_INTEGER_ERROR, value.toString());
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return IntegerValidator;
}(Validator_1.Validator);

exports.IntegerValidator = IntegerValidator;
IntegerValidator.NOT_INTEGER_ERROR = 'NOT_INTEGER';